import React from 'react';

import Heading from '@tds/core-heading';
import Box from '@tds/core-box';
import HairlineDivider from '@tds/core-hairline-divider';
import DimpleDivider from '@tds/core-dimple-divider';

import { Container } from './styles';
import Form from '../form/fields/defectManagementFields/index';

import DefectManagement from '../defectManagement';
import { useLocaleContext } from '../context/LocaleContext';
import EN from '../../EN.json';
import FR from '../../FR.json';

const ReportAnIssue = () => {
  const locale = useLocaleContext();
  const {
    DEFECT_MANAGEMENT: { TITLE }
  } = locale === 'en-US' ? EN : FR;

  return (
    <>
      <div className="container 85%">
        <Container>
          <Box between={4}>
            <Heading level="h2">{TITLE}</Heading>
            <HairlineDivider gradient />
            <Form />
          </Box>
        </Container>
      </div>
      <DimpleDivider />
      <DefectManagement />
    </>
  );
};

export default ReportAnIssue;

